export default "__VITE_ASSET__ZE_oJfnU__"